import { render } from "./ConsentForm1.vue?vue&type=template&id=910f5cae&scoped=true"
import script from "./ConsentForm1.vue?vue&type=script&lang=js"
export * from "./ConsentForm1.vue?vue&type=script&lang=js"

import "./ConsentForm1.vue?vue&type=style&index=0&id=910f5cae&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910f5cae"]])

export default __exports__